import { jsx as r } from "react/jsx-runtime";
import { DealCard as p } from "../DealCard/index.js";
import { DealSavedCardActions as D } from "../components/DealSavedCardActions/index.js";
const g = ({
  id: o,
  status: t,
  commentCount: a,
  temperature: n,
  isSaved: d,
  isNotificationsActived: l,
  actions: e,
  className: m,
  cashbackPercentage: c,
  ...i
}) => /* @__PURE__ */ r(
  p,
  {
    id: o,
    status: t,
    dispatch: e,
    bottomContent: /* @__PURE__ */ r(
      D,
      {
        deal: {
          id: o,
          status: t,
          commentCount: a,
          temperature: n
        },
        actionHandler: e,
        isSaved: d,
        isNotificationsActived: l
      }
    ),
    className: m,
    cashbackPercentage: c,
    ...i
  }
);
export {
  g as DealSavedCard
};
